export const HEADER_HEIGHT = 42;
export const ROW_HEIGHT = 50;

export const WIDTH_CHECKBOX = 50;
